module.exports = {
    'dev.localclarity.com': 'support@localclarity.com',
    'app.reputate.co.za': 'support@localclarity.com',
    'localhost:8000': 'support@localclarity.com',
    'localhost:3000': 'support@localclarity.com',
    'app.localclarity.com': 'support@localclarity.com',
    'mig.localclarity.com': 'support@localclarity.com',
    'reputationmanager.io': 'support@reputationmanager.com',
    'reviews.10thousandfeet.com': 'research@10thousandfeet.com',
    'app.gearseo.com.br': 'contato@gearseo.com.br',
    'reviews.insiderperks.com': 'hello@insiderperks.com',
    'gmb.insyghts.io': 'support@localclarity.com',
    'reputationmanager.freshfeedback.ca': 'info@freshfeeback.ca',
    'insights.setmysite.com': 'info@setmysite.com',
    'local.mickeyllew.co.za': 'hello@mickeyllew.co.za',
    'reviews.marketingbyrob.com': 'team@marketingbyrob.com',
    'places.gvp.digital': 'places@gvp.com.br',
    'app.bizzrep.com': 'hello@bizzrep.com',
    'app.localclarity.com.br': 'support@localclarity.com',
    'locations.localorm.com': 'support@localorm.com',
    'app.ormanagement.co': 'hello@ormanagement.co',
    'cloud.mybusiness.tw': 'service@cloudad.ai',
    'app.beoordeel.online': 'support@beoordeel.online',
    'canada.localclarity.com': 'support@localclarity.com',
    'app.localtouch.io': 'support@localclarity.com',
    'stage.localclarity.com': 'support@localclarity.com',
    'reputation.easyfishmarketing.com': 'support@easyfishmarketing.com',
    'local.findyouraudience.online': 'localsupport@findyouraudience.online',
    'gmn.astradigital.com.br': 'suporte@astradigital.com.br',
    'reputation.itsevolve.com': 'reputation@itsevolve.com',
    'reviews.flextsms.com': 'info@flextsms.com',
    'grow.digimarketer.ca': 'support@digimarketer.ca',
    'local.leadcrossing.com': 'local@leadcrossing.com',
    'reputation.apt.co.ke': 'engage@apt.co.ke',
    'reviews.skyeline.com': 'support@reviews.skyeline.com',
    'reviews.engageq.com': 'info@engageQ.com',
    'reviews.motivatedmarketing.com': 'seoteam@motivatedmarketing.com',
    'control.wela.com': 'info@wela.com',
    'reputation.thatsbiz.com':'support@reputation.thatsbiz.com',
    'app.getlocaladvantage.com':'support@getlocaladvantage.com',
    'client.googavis.fr': 'assistance@googavis.fr',
    'app.googlebusiness.ca':'contact@googlebusiness.ca',
    'app.hospitality-buddy.eu':'info@hospitality-buddy.eu',
    'orm.marinemarketingsolutions.net':'digital@marinemarketingsolutions.net',
    'footfall.opositive.io':'hello@opositive.io',
    'reply.asterfive.com':  'Jeff@fmcreativesolutions.com',
    'app.onereputation.it':'info@onereputation.it',
    'reviews.rankmeone.ai':'brad@rankmeone.ai',
    'respond.overallreviews.com':'info@overallreviews.com',
    'reviews.restauranter.pt':'restauranter.pt@gmail.com',
    'reviews.overthetopseo.com':'support@reviews.overthetopseo.com',
};